import { useExplore } from "@modules/new-explore/hooks/useExplore";
import {
  EXPLORE_SORT_QUERY,
  normalizeExploreSortQuery,
} from "enums/new-explore/explore-sort";
import { useRouter } from "next/router";
import {
  EXPLORE_SLUG,
  EXPLORE_STATUS,
  exploreSortItems,
} from "types/api/explore";

export const useExploreSort = () => {
  const router = useRouter();
  const { query } = router;
  const { addFilter, addFilters } = useExplore();

  const slug =
    typeof query.slug === "string"
      ? (query.slug as EXPLORE_SLUG)
      : EXPLORE_SLUG.COURSE;

  const isTermExist = Boolean(query.term);

  const defaultSort =
    slug === EXPLORE_SLUG.COURSE
      ? EXPLORE_SORT_QUERY.POPULAR
      : EXPLORE_SORT_QUERY.NEWEST;

  const activeSort = (normalizeExploreSortQuery(
    (query.sort as string) || defaultSort
  ) || defaultSort) as EXPLORE_SORT_QUERY;

  const sortItems =
    slug === EXPLORE_SLUG.INSTRUCTOR
      ? []
      : isTermExist
        ? exploreSortItems
        : exploreSortItems.filter((item) => item?.isCommon) || [];

  const activeSortItem = sortItems.find((item) => item.query === activeSort);

  const activeSortLabel = query.sort
    ? activeSortItem?.persian_name || "پرمخاطب‌ترین"
    : "مرتب‌سازی";

  const handleSelectSort = (
    name: EXPLORE_SORT_QUERY,
    onComplete?: () => void
  ) => {
    if (
      name === EXPLORE_SORT_QUERY.NEWEST &&
      (query.slug === undefined || query.slug === EXPLORE_SLUG.COURSE) &&
      !query.publish_status
    ) {
      addFilters({
        data: [
          {
            filterName: "publish_status",
            value: EXPLORE_STATUS.PUBLISHED,
            name: "منتشر شده",
          },
          { filterName: "sort", value: name, name: "" },
        ],
        isSingle: true,
      });
    } else {
      addFilter({
        filterName: "sort",
        value: name,
        name: "",
        isSingle: false,
        withReplace: true,
      });
    }

    if (onComplete) {
      onComplete();
    }
  };

  const handleSearchWithTerm = (termValue: string) => {
    addFilters({
      data: [
        {
          filterName: "sort",
          value: EXPLORE_SORT_QUERY.RELEVANT,
          name: "",
        },
        { filterName: "term", value: termValue, name: "" },
        { filterName: "page", value: "1", name: "" },
      ],
      isSingle: true,
      clear: false,
    });
  };

  const isSortActive = (sortQuery: EXPLORE_SORT_QUERY) =>
    activeSort === sortQuery;

  return {
    activeSort,
    activeSortItem,
    activeSortLabel,
    sortItems,
    handleSelectSort,
    handleSearchWithTerm,
    isSortActive,
  };
};
